<form [formGroup]="form" class="g-slider-container form-wrapper">
    @if (showRestrictionsNotification) {
        <app-message-block
                [type]="toasterType.Warning"
                [message]="restrictionsMessage"
        ></app-message-block>
    }
    @if (showDuplicateNetworkElements) {
        <div class="g-field-area">
            <label>{{ otAgentsTexts.edit_agent.duplicate_networks_title }}</label>
            <p class="message">{{ otAgentsTexts.edit_agent.duplicate_networks_message_prefix }}
                <b>{{ duplicateNetworksText }}</b>
                {{ otAgentsTexts.edit_agent.duplicate_networks_message_suffix }}
            </p>
            <div class="g-input-area">
                <app-checkbox [formControl]="scanDuplicatedNetworks"></app-checkbox>
                <label>{{ otAgentsTexts.edit_agent.duplicate_networks_label }}</label>
            </div>
        </div>
    }
    <div class="g-field-area">
        <label for="name">{{ otAgentsTexts.edit_agent.name }}</label>
        <input id="name"
               class="g-large-field"
               [formControl]="name"
        />
        <app-validation-message [messageText]="errorTexts.empty_name"
                                [validation]="formValidatorsService.isEmpty(name)"
        ></app-validation-message>
    </div>

    <div class="g-field-area">
        <span>{{ otAgentsTexts.edit_agent.active_query_networks }}</span>
        <textarea id="activeNetworks"
                  [placeholder]="otAgentsTexts.edit_agent.help_tip"
                  [formControl]="activeNetworks"
        ></textarea>
        <app-validation-message [messageText]="errorTexts.invalid_ip"
                                [validation]="formValidatorsService.isInvalidIp(activeNetworks)"
        ></app-validation-message>
    </div>

    <div class="g-field-area">
        <app-form-toggle-box
                [config]="{text: otAgentsTexts.edit_agent.run_schedule_scan}"
                [formControl]="enableSchedule"></app-form-toggle-box>
    </div>

    <app-form-frequency-editor [formControl]="schedule"></app-form-frequency-editor>

    @if (credentialsOptions) {
    <div class="g-field-area">
        <app-ui-select [label]="otAgentsTexts.edit_agent.credentials" [options]="credentialsOptions" [formControl]="credentials"
                       class="g-large-field" [multiSelect]="true"></app-ui-select>
        <div class="credentials-info">
            <app-icon [svgIcon]="IconsEnum.info"></app-icon>
            <p>{{otAgentsTexts.edit_agent.credentials_tip}}</p>
        </div>
    </div>
    }
</form>
